import api from './api';
import {AppResponse} from "../models/common/app-response";
import { PaginatedResponse } from '../models/common/paginated-response';
import { MedicalJournalFilter } from '../models/medicalCheckups/medicalJournalFilter';
import { MedicalJournalShortDto } from '../models/medicalCheckups/medicalJournalShortDto';
import { CreateMedicalJournalDto } from '../models/medicalCheckups/createMidicalJournalDto';
import { LinkObjectDto } from '../models/common/linkObjectDto';
import { BulkSignMedicalJournalsWithPhysicalTokenDto } from '../models/medicalJournals/bulkSignMedicalJournalsWithPhysicalTokenDto';
import { MedicalJournalAndHashDto } from '../models/medicalJournals/medicalJournalAndHashDto';

class MedicalJournalsService {

    baseUrl: string = "/api/v1/medical-journals";

    getByFilter(filter? : MedicalJournalFilter) {
        return api.post<AppResponse<PaginatedResponse<MedicalJournalShortDto>>>(`${this.baseUrl}/filter`, filter);
    }

    create(data : CreateMedicalJournalDto) {
        return api.post<AppResponse<number>>(this.baseUrl, data);
    }

    getDownloadLink(id: number) {
        return api.get<AppResponse<LinkObjectDto>>(this.baseUrl + `/${id}/download-link`);
    }

    downloadPdf(id: number) {
        return api.get(this.baseUrl + `/${id}/download-pdf`, { responseType: 'blob' });
    }

    /**
     * Массовое подписание журналов облачным токеном.
     */
    bulkSignWithCloudToken(journalIds: number[]) {
        return api.post<AppResponse<number>>(`${this.baseUrl}/bulk-sign/cloud-token`, { journalIds });
    }

    /**
     * Массовое подписание журналов физическим токеном.
     */
    bulkSignWithPhysicalToken(data: BulkSignMedicalJournalsWithPhysicalTokenDto) {
        return api.post<AppResponse<number>>(`${this.baseUrl}/bulk-sign/physical-token`, data);
    }

    /**
     * Создание хешей журналов для подписания физическим токеном.
     */
    createHashes(journalIds: number[]) {
        return api.post<AppResponse<Record<number, MedicalJournalAndHashDto>>>(`${this.baseUrl}/hash`, { journalIds }).then((data) => data.data.data);
    }
}

export const medicalJournalsService = new MedicalJournalsService();